import type { ComponentPropsWithoutRef } from 'react';

const PADDING_CLASS = {
  sm: 'py-10 sm:py-14',
  md: 'py-16 sm:py-24',
  lg: 'py-24 sm:py-32',
} as const;

type SectionPadding = keyof typeof PADDING_CLASS;

interface SectionProps extends ComponentPropsWithoutRef<'section'> {
  padding?: SectionPadding;
  bordered?: boolean;
}

export function Section({
  padding = 'md',
  bordered = false,
  className,
  ...props
}: SectionProps) {
  return (
    <section
      className={[
        'w-full',
        PADDING_CLASS[padding],
        bordered ? 'border-y border-border' : '',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      {...props}
    />
  );
}
